<template>
  <div
    class="card"
   :class="{'mb-5': !noMargin}"
  >
    <slot class="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    noMargin: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
.card {
  background: rgb(var(--background-color));
  box-shadow: 0 1px 4px rgba(var(--shadow-color), 0.25);
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 15px;
  border-radius: 10px;
}

.cardTitle,
:slotted(.cardTitle) {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
}

.cardSubTitle,
:slotted(.cardSubTitle) {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: rgba(var(--black-color), 0.6);
}
</style>